<button
  *nodaResponsiveIf="[enMinWidthScreen.LG]"
  type="button"
  class="cart-control"
  @toggleButton
  (click)="clicked.emit()"
>
  <ng-container *ngTemplateOutlet="arrowTemplateRef()" />

  <div class="cart-control__counter">
    <ng-container *ngTemplateOutlet="cartCounterTemplateRef" />
  </div>
</button>

<button
  type="button"
  class="cart-control-mobile"
  @toggleButtonSM
  (click)="clicked.emit()"
>
  <ng-container *ngTemplateOutlet="cartCounterTemplateRef" />
</button>


<ng-template #cartCounterTemplateRef>
  <svg-icon
    name="icons/icon-cart.svg#cart"
    class="icon-cart"
    [size]="24"
  />

  <sup class="p4-website">{{ counter() }}</sup>
</ng-template>
